import { ChangeStoreStyles } from "@omni/ui/brand/callToActions/changeStore/changeStore.styles";
import { Button } from "@omni/ui/components/Button/button.component";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { useStorePickerContext } from "@/components/Store/StorePicker/storePicker.context";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { isLoading } from "@/redux/modules/api/data/cart/cart.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type SubmitChangeStoreProps = {
    product: CartItemModel | null;
    onCancel: () => void;
    onChangeStore: (storeId: string) => void;
};

export const SubmitChangeStore = ({
    product,
    onCancel,
    onChangeStore
}: SubmitChangeStoreProps) => {
    const { t } = useGranite();

    const isLoadingChangeStore = useSelector(isLoading);

    const { selectedStore } = useStorePickerContext();

    const handleOnSubmitClick = () => {
        if (!isDefined(selectedStore)) return;

        onChangeStore(selectedStore.code);
    };

    const disabled = !isDefined(selectedStore);

    return (
        <div
            className={cn(
                "tw:flex tw:w-full tw:m-0 tw:mt-2 tw:sm:mt-4 tw:items-center",
                product ? "tw:justify-between" : "tw:justify-end"
            )}
        >
            {product && (
                <Button
                    test="changeStore-button-cancel"
                    color="link"
                    type="button"
                    className={cn("tw:px-0")}
                    onClick={onCancel}
                >
                    <i className="las la-angle-left" />
                    {t("general.button.cancel")}
                </Button>
            )}
            <Button
                test="changeStore-button-changeStore"
                type={"button"}
                color={ChangeStoreStyles.confirmButton?.color || "success"}
                onClick={handleOnSubmitClick}
                loading={isLoadingChangeStore}
                disabled={disabled}
            >
                {t("cta.changeStore.action.changeStore")}
            </Button>
        </div>
    );
};
